// extracted by mini-css-extract-plugin
export var container = "_dm-0";
export var infoIcon = "_dm-2";
export var internalLabel = "_dm-3";
export var titleRowCol = "_dm-1";